import { Calc } from "../../math/Calc.js";
import { ScrollbarData } from "../Scrollbar.js";
import { ScrollbarListDynamic } from "../ScrollbarListDynamic.js";
import { IScrollbarBehaviour } from "./IScrollbarBehaviour.js";

export class ScrollbarBehaviourPureIndex implements IScrollbarBehaviour {
    public getIndex(scrollbar: ScrollbarListDynamic): number {
        var trackRange = scrollbar.track.offsetHeight - scrollbar.thumb.offsetHeight;
        var maxIndex = scrollbar.view.getItems().length - 1;
        var ratio = scrollbar.dragger.top / trackRange;
        var index = Calc.clamp(Math.round(ratio * maxIndex), 0, maxIndex);
        return index;
    }

    public fromView(scrollbar: ScrollbarListDynamic): ScrollbarData {
        var items = scrollbar.view.getItems();
        var maxEntries = items.length;
        var firstIndex = scrollbar.view.first ? scrollbar.view.first.index : 0;
        return {
            scrollHeight: maxEntries,
            scrollTop: firstIndex,
            clientHeight: 1
        };
    }
}